import { useParams } from "react-router-dom";
import { useAzureImageDownload } from "src/components/AssetUploaders/useAzureImageDownload";

const ProtectedImageView = () => {
	const params = useParams<{
		imageId: string;
	}>();

	const imageId = params.imageId;

	const { url: image } = useAzureImageDownload(
		"image",
		"",
		imageId,
		"observation-question-upload",
		"full"
	);

	return (
		<img
			src={image}
			alt="observation image"
			className="max-w-full h-screen object-contain"
		/>
	);
};

export default ProtectedImageView;
